/* Header */
.headerRef {
    font-size: var(--mantine-font-size-sm);
    color: var(--mantine-color-dimmed);
}

.summary {
    display: flex;
    gap: var(--mantine-spacing-lg);
}

.stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.05;
}

.statValue {
    font-size: 1.9rem;
    font-weight: 700;
}

.statLabel {
    font-size: var(--mantine-font-size-xs);
    color: var(--mantine-color-dimmed);
}

/* Uppercase eyebrow labels */
.eyebrow {
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--mantine-color-dimmed);
}

/* Custom step indicator */
.stepper {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-md) 0;
    border-top: 1px solid var(--mantine-color-gray-2);
    border-bottom: 1px solid var(--mantine-color-gray-2);
}

.step {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-sm);
    flex: 0 0 auto;
}

.stepCircle {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    font-size: var(--mantine-font-size-sm);
    font-weight: 700;
}

.stepDone {
    background-color: var(--mantine-color-teal-6);
    color: var(--mantine-color-white);
}

.stepActive {
    background-color: var(--mantine-color-blue-0);
    border: 2px solid var(--mantine-color-blue-6);
    color: var(--mantine-color-blue-7);
}

.stepUpcoming {
    background-color: var(--mantine-color-gray-1);
    border: 2px solid var(--mantine-color-gray-3);
    color: var(--mantine-color-gray-6);
}

.stepEyebrow {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--mantine-color-dimmed);
}

.stepEyebrowActive {
    color: var(--mantine-color-blue-7);
}

.stepLabel {
    font-weight: 600;
    line-height: 1.2;
}

.stepConnector {
    flex: 1 1 auto;
    min-width: 24px;
    height: 2px;
    background-color: var(--mantine-color-gray-3);
}

.stepConnectorDone {
    background-color: var(--mantine-color-teal-6);
}

/* Schedule row */
.scheduleRow {
    display: flex;
    flex-wrap: wrap;
    gap: var(--mantine-spacing-xl);
    align-items: flex-end;
}

.scheduleField {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.patternControl label[data-active] {
    color: var(--mantine-color-blue-7);
    font-weight: 600;
}

.pickupValue {
    font-size: var(--mantine-font-size-lg);
    font-weight: 700;
    color: var(--mantine-color-teal-7);
}

/* Violet cadence bar */
.cadenceBar {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-md);
    flex-wrap: wrap;
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    background-color: var(--mantine-color-violet-0);
    border: 1px solid var(--mantine-color-violet-1);
    border-radius: var(--mantine-radius-md);
}

.cadenceIcon {
    display: flex;
    color: var(--mantine-color-violet-6);
}

.cadenceSummary {
    margin-left: auto;
    font-size: var(--mantine-font-size-sm);
    font-weight: 700;
    color: var(--mantine-color-violet-7);
}

.weekdayGroup {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.weekday {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid var(--mantine-color-gray-2);
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-gray-0);
    color: var(--mantine-color-gray-6);
    font-size: var(--mantine-font-size-sm);
    font-weight: 700;
    cursor: pointer;
    transition:
        background-color 120ms ease,
        color 120ms ease,
        border-color 120ms ease;
}

.weekday:hover {
    background-color: var(--mantine-color-gray-1);
}

.weekdaySelected {
    background-color: var(--mantine-color-violet-6);
    border-color: var(--mantine-color-violet-6);
    color: var(--mantine-color-white);
}

.weekdaySelected:hover {
    background-color: var(--mantine-color-violet-7);
}

/* Build-out header */
.buildoutHeader {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: var(--mantine-spacing-md);
    flex-wrap: wrap;
}

/* Two-column job cards */
.jobCard {
    border: 1px solid var(--mantine-color-gray-2);
    border-radius: var(--mantine-radius-md);
    overflow: hidden;
}

.jobGrid {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.jobPanel {
    flex: 0 0 190px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: var(--mantine-spacing-md);
    border-right: 1px solid var(--mantine-color-gray-1);
}

.jobPanelDeploy {
    background-color: var(--mantine-color-blue-0);
}

.jobPanelService {
    background-color: var(--mantine-color-violet-0);
}

.jobPanelPickup {
    background-color: var(--mantine-color-teal-0);
}

.jobLabel {
    font-weight: 700;
}

.jobFlag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--mantine-color-violet-6);
}

.jobReqs {
    flex: 1 1 320px;
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-md);
}

/* Requirement chips */
.reqChips {
    display: flex;
    flex-wrap: wrap;
    gap: var(--mantine-spacing-sm);
}

.chip {
    display: inline-flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: 5px 12px;
    background-color: var(--mantine-color-body);
    border: 1px dashed var(--mantine-color-gray-4);
    border-radius: var(--mantine-radius-xl);
    font-size: var(--mantine-font-size-sm);
}

.chipMuted {
    border-color: var(--mantine-color-violet-2);
    color: var(--mantine-color-dimmed);
}

.chipDot {
    flex: 0 0 auto;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.chipTag {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--mantine-color-gray-5);
}

/* Compact editable template/override chips */
.templateChip {
    display: inline-flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: 3px 4px 3px 12px;
    background-color: var(--mantine-color-body);
    border: 1px solid var(--mantine-color-violet-2);
    border-radius: var(--mantine-radius-xl);
}

.templateSelect input {
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    min-width: 110px;
}

.addChip {
    border-style: dashed;
}

/* Footer hand-off bar */
.handoffBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--mantine-spacing-lg);
    flex-wrap: wrap;
    padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
    background-color: var(--mantine-color-gray-0);
    border: 1px solid var(--mantine-color-gray-2);
    border-radius: var(--mantine-radius-md);
}
